// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/userHome/userDetails/userDetails.component.less
// module id = 365
// module chunks = 0